import { system } from 'styled-system';
import { getPxAbsolute } from '../internal';

const borderBottomLeftRadius = system({
  radiusBR: {
    property: 'borderBottomRightRadius',
    scale: 'radii',
    transform: getPxAbsolute,
  },
});

export default borderBottomLeftRadius;
